import { FC } from 'react';
import { Wrapper } from '../../../components/shared/essential-ui/back-button/BackButton';
import { useHeapTrack } from '../../../hooks/UseHeapTrack';
import { PrivateIncentiveLookupSearchResultProps } from '../../../types/PrivateIncentiveLookup';
import PrivateIncentiveDetails from './PrivateIncentiveDetails';
import { WrapperPrivateIncentiveLookupSearchResult } from './style';

const PrivateIncentiveLookupSearchResult: FC<PrivateIncentiveLookupSearchResultProps> = (props) => {
  const privateIncentives = props.privateIncentiveDetails.sort((a, b) => {
    if (new Date(a.endDate) > new Date(b.endDate)) {
      return -1;
    } else {
      return 1;
    }
  });

  const storeCode = localStorage.getItem('am.storeCode');
  const handleBackBtnClick = () => {
    if (props.onSearchViewChange) {
      useHeapTrack('Private Incentive Lookup - Back Button', { StoreCode: storeCode });
      props.onSearchViewChange();
    }
  };

  return (
    <WrapperPrivateIncentiveLookupSearchResult>
      {props.type !== 'modal' && (
        <div className='row'>
          <div className='col-lg-12 col-md-12 header-row'>
            <div className='col-1'>
              <Wrapper onClick={handleBackBtnClick} data-testid='back-button' marginTop={25}>
                Back
              </Wrapper>
            </div>
            <div className='col-11 header-text-result'>Private Incentive</div>
          </div>
        </div>
      )}

      <div className='incentive-card'>
        {privateIncentives &&
          privateIncentives.map((item, index) => {
            return (
              <PrivateIncentiveDetails
                key={index}
                {...item}
                type={props.type}
              ></PrivateIncentiveDetails>
            );
          })}
      </div>
    </WrapperPrivateIncentiveLookupSearchResult>
  );
};

export default PrivateIncentiveLookupSearchResult;
